//#region Imports
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
//#endregion Imports
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  //#region Inputs, Outputs, ViewChilds
  //#endregion Inputs, Outputs, ViewChilds

  //#region Public Variables
  public Message: string = null;
  public Title: string = null;
  public Subtitle: string = null;
  public IsDeleteAction : boolean = false;
  //#endregion Public Variables

  //#region Private Variables
  //#endregion Private Variables

  //#region Properties
  //#endregion Properties

  //#region Constructor and Angular Life Cycle
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  public ngOnInit(): void {
    const defaultTitle: string = 'Confirm Change';
    const defaultSubtitle: string = 'This will delete everything in this section.';
    const defaultMessage: string = 'Please confirm if you would like to proceed with this change.';

    this.data = this.data || {};
    this.Title = this.data.title || defaultTitle;
    this.Subtitle = this.data.subtitle || defaultSubtitle;
    this.Message = this.data.message || defaultMessage;

    this.IsDeleteAction = this.Title === 'Delete Confirmation';
  }
  //#endregion Constructor and Angular Life Cycle

  //#region Event Handlers
  //#endregion Event Handlers

  //#region Public Methods
  public OnConfirmClick(): void {
    this.dialogRef.close(true);
  }

  public OnCancelClick(): void {
    this.dialogRef.close(false);
  }
  //#endregion Public Methods

  //#region Private Methods
  //#endregion Private Methods
}
